<template lang="html">
  <div class="student-video-chat" :class="{ 'hand-raised': student.hand_raised, 'talking': !student.muted }">
    <font-awesome-icon icon="sad-tear" class="modalstudent-video-chat__student student-video-chat__student--svg" v-if="!student.active"/>
    <font-awesome-icon icon="user" class="student-video-chat__student student-video-chat__student--svg" v-else-if="!student.has_media"/>
    <video class="student-video-chat__student" ref="video-player" autoplay :muted="student.muted" v-else/>
    <div class="student-video-chat__student__options" v-if="canMute && student.active">
      <div class="student-video-chat__student__options__icon volume" @click="setMuted({ student_id: student._id, muted: !student.hand_raised ? !student.muted : false })" v-if="student.has_media">
        <font-awesome-icon :icon="student.muted ? 'volume-mute' : 'volume-up'"/>
      </div>
      <div class="student-video-chat__student__options__icon attention" v-if="student.hand_raised" @click="setMuted({ student_id: student._id, muted: !student.hand_raised ? !student.muted : false })">
        <font-awesome-icon icon="hand-paper"/>
      </div>
    </div>
    <span>{{ student.name }}</span>
  </div>
</template>

<script>
export default {
  name: 'student-video-chat',
  props: {
    student: {
      type: Object,
      required: true
    },
    canMute: {
      type: Boolean,
      default: false
    },
    setMuted: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    setStream (stream) {
      this.$nextTick(() => {
        this.$refs['video-player'].srcObject = stream
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './src/assets/css/base/variables';

.student-video-chat {
  position: relative;
  min-width: 200px;
  max-width: calc((100% / 6) - (6 * 10px));
  height: auto;
  padding: 5px;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  margin: 5px;
  &__student {
    width: auto;
    height: auto;
    max-width: calc(100% - 10px);
    max-height: calc(100% - 10px);
    video {
      width: 100%;
      height: auto;
    }

    &__options {
      position: absolute;
      left: 0;
      top: 0;
      flex: 1;
      transition: display .2s;
      width: 100%;
      height: auto;
      margin: 5px;
      padding: 5px;

      &__icon {
        float: right;
        margin-right: 15px;
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 25px;

        &.volume {
          background-color: $color-blue-dark;
        }

        &.attention {
          background-color: $color-red;
        }
      }
    }
  }
  &__student--svg {
    width: 63% !important;
    height: auto;
  }
  &.hand-raised {
    border: 2px solid $color-red;
    padding: 3px;
    .student-video-chat__student__options {
      top: -2px;
      left: 2px;
    }
  }
  &.talking {
    border: 2px solid $color-blue-dark;
    padding: 3px;
    .student-video-chat__student__options {
      top: -2px;
      left: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StudentVideoChat/index.vue